const getBadgeText = (label) => {
  if (!label) return "";
  const dataText = label.dataset.badgeText;
  if (dataText && dataText.trim()) return dataText.trim();
  return label.innerText.trim();
};

const setBadgeText = (label, text) => {
  if (!label) return;
  const normalized = (text || "").trim();
  label.dataset.badgeText = normalized;
  label.innerText = normalized;
};

const isComingSoonBadge = () => {
  const badge = document.querySelector(".labelBadge");
  const text = getBadgeText(badge).toLowerCase();
  return text === "coming soon";
};

const updateProductBadge = () => {
  const prdctBadgeLabels = document.querySelectorAll(".labelBadge");
  const classesToRemove = [
    "bg-green-3",
    "bg-gray-3",
    "bg-blue-3",
    "bg-black",
    "bg-yellow-3",
    "border-green-4",
    "bg-red-3",
    "text-black",
    "text-white",
    "text-green-4",
    "border-2",
    "bg-blue-5",
    "invisible",
    "d-none",
  ];

  const badgeColors = [
    { badgeText: "no longer available", bg: "bg-gray-3", text: "text-black" },
    { badgeText: "sale", bg: "bg-red-3", text: "text-black" },
    { badgeText: "new", bg: "bg-green-3", text: "text-black" },
    { badgeText: "sold out", bg: "bg-gray-3", text: "text-black" },
    { badgeText: "refurbished", bg: "bg-blue-3", text: "text-white" },
    { badgeText: "certified refurbished", bg: "bg-blue-3", text: "text-white" },
    { badgeText: "best seller", bg: "bg-yellow-3", text: "text-black" },
    { badgeText: "out of stock", bg: "bg-gray-3", text: "text-black" },
    { badgeText: "b-stock", bg: "bg-blue-5", text: "text-white" },
    { badgeText: "pre-order", bg: "border-green-4", text: "text-green-4", border: "border-2" },
    { badgeText: "coming soon", bg: "bg-black", text: "text-white" },
  ];

  prdctBadgeLabels.forEach((label) => {
    if (!label) return;

    const text = getBadgeText(label).toLowerCase();

    // Build the new class list before making any changes (prevents flashing)
    const newClasses = [];
    if (!text) {
      newClasses.push("d-none");
    } else {
      const matchedColor = badgeColors.find((color) => text === color.badgeText);
      if (matchedColor) {
        newClasses.push(matchedColor.bg, matchedColor.text);
        if (matchedColor.border) newClasses.push(matchedColor.border);
      }
    }

    // Apply changes atomically - remove old and add new in one operation
    // This prevents flashing by ensuring styles are always applied
    const currentClasses = [...label.classList];
    const classesToActuallyRemove = currentClasses.filter(
      (cls) => classesToRemove.includes(cls) && !newClasses.includes(cls)
    );

    if (classesToActuallyRemove.length > 0) {
      label.classList.remove(...classesToActuallyRemove);
    }
    if (newClasses.length > 0) {
      label.classList.add(...newClasses);
    }
  });

  // Note: checkSoldOut() is intentionally NOT called here to avoid race conditions.
  // checkSoldOut() should be called explicitly with the correct 'available' parameter
  // after the badge is updated in renderProductInfo().
};

const syncProductBadge = (html, sourceSectionId, destinationSectionId) => {
  const sourceRoot = html || document;

  // Try to find source badge by ID first, then fall back to first .labelBadge
  let sourceLabel = sourceRoot.getElementById(
    `product__label-${sourceSectionId}`
  );
  if (!sourceLabel) {
    // Fallback: get first labelBadge in fetched HTML
    sourceLabel = sourceRoot.querySelector?.(".labelBadge");
  }

  const destinationLabel = document.getElementById(
    `product__label-${destinationSectionId}`
  );
  const resolvedDestinationLabel =
    destinationLabel ||
    document.querySelector(
      `#MainProduct-${destinationSectionId} .labelBadge`
    );

  if (!resolvedDestinationLabel) {
    updateProductBadge();
    return;
  }

  // Update badge if source element exists in fetched HTML
  if (sourceLabel) {
    const newText = getBadgeText(sourceLabel);
    setBadgeText(resolvedDestinationLabel, newText);
  }
  updateProductBadge();
};

const bindBadgeVariantInputs = () => {
  document
    .querySelectorAll('select[name="id"], [type="radio"][name="id"]')
    .forEach((input) => {
      input.addEventListener("change", () => {
        setTimeout(updateProductBadge, 100);
      });
    });
};

const getVariantPayload = (event) => {
  if (!event) return null;
  return event.data || event.detail || event;
};

if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const payload = getVariantPayload(event);
    const sectionId = payload?.sectionId;
    let html = payload?.html;
    if (typeof html === "string") {
      html = new DOMParser().parseFromString(html, "text/html");
    }
    if (!sectionId || !html) {
      updateProductBadge();
      return;
    }
    syncProductBadge(html, sectionId, sectionId);
  });
}

document.addEventListener("variant:change", (event) => {
  const payload = getVariantPayload(event);
  const sectionId = payload?.sectionId;
  let html = payload?.html;
  if (typeof html === "string") {
    html = new DOMParser().parseFromString(html, "text/html");
  }
  if (!sectionId || !html) {
    updateProductBadge();
    return;
  }
  syncProductBadge(html, sectionId, sectionId);
});

document.addEventListener("DOMContentLoaded", () => {
  updateProductBadge();
  bindBadgeVariantInputs();
});

window.isComingSoonBadge = isComingSoonBadge;
window.updateProductBadge = updateProductBadge;
window.syncProductBadge = syncProductBadge;
